export class UserInfoViewModel {
  constructor(
    readonly userId: string,
    readonly name: string) {
  }

  toString(): string {
    return `UserId: ${this.userId}, Name: ${this.name}`;
  }
}